/**
 * Accordion Block
 */
(() => {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Accordion toggle
    document.querySelectorAll('.accordion__trigger').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        const panel = document.getElementById(trigger.getAttribute('aria-controls'));

        if (!panel) return;

        if (expanded) {
          if (prefersReducedMotion) {
            panel.style.maxHeight = '0';
          } else {
            panel.style.maxHeight = `${panel.scrollHeight}px`;
            panel.offsetHeight; // force reflow
            panel.style.maxHeight = '0';
          }
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = prefersReducedMotion ? 'none' : `${panel.scrollHeight}px`;
        }
      });
    });

    // After open transition ends, set maxHeight to none so content can reflow
    document.querySelectorAll('.accordion__panel').forEach((panel) => {
      panel.addEventListener('transitionend', () => {
        const trigger = panel.previousElementSibling;
        if (trigger && trigger.getAttribute('aria-expanded') === 'true') {
          panel.style.maxHeight = 'none';
        }
      });
    });

    // Show More
    document.querySelectorAll('.accordion__show-more').forEach((button) => {
      button.addEventListener('click', () => {
        const section = button.closest('.accordion');
        if (!section) return;

        section.querySelectorAll('.accordion__item--hidden').forEach((item) => {
          item.classList.remove('accordion__item--hidden');
        });

        button.style.display = 'none';
      });
    });
  });
})();
